/**
 * The product selection module's assistant views (design D20), registered in
 * `registry.ts` like `quotesAgentViews`: `product_selection`, the card where
 * the user reviews the assistant's product picks and takes them over.
 */
import { ProductSelectionView } from "./ProductSelectionView.js";
import { isProductSelectionView } from "./productSelectionSpec.js";
import type { AgentViewComponent } from "./registry.js";

export const ProductSelectionAgentView: AgentViewComponent = ({
  view,
  onSend,
  busy,
  answeredWith,
}) => {
  if (!isProductSelectionView(view)) return null;
  return (
    <ProductSelectionView
      view={view}
      busy={busy}
      answeredWith={answeredWith}
      onSend={onSend}
    />
  );
};

export const productSelectionAgentViews: Record<string, AgentViewComponent> = {
  product_selection: ProductSelectionAgentView,
};
